export enum Step {
  Login = 'login',
  ParentStart = 'parent_start',
  ParentIntermediate = 'parent_intermediate',
  ParentFinal = 'parent_final',
}
